import { render, staticRenderFns } from "./MyFavoritesItem.vue?vue&type=template&id=06487833&scoped=true&"
import script from "./MyFavoritesItem.vue?vue&type=script&lang=js&"
export * from "./MyFavoritesItem.vue?vue&type=script&lang=js&"
import style0 from "./MyFavoritesItem.vue?vue&type=style&index=0&id=06487833&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06487833",
  null
  
)

export default component.exports